import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                韩漫网站
              </Link>
            </h4>
            <p className="text-foreground-400 text-sm leading-relaxed">
              韩国漫画免费在线阅读平台，提供下拉式韩漫全集阅读服务。漫画大全涵盖多种类型，让您随时随地畅享好看的韩国漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">漫画分类</h4>
            <ul className="space-y-2.5">
              {comicCategories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['韩国漫画免费', '下拉式韩漫', '在线阅读', '漫画大全', '免费漫画', '热门韩漫'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 bg-foreground-800 text-foreground-300 text-xs rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2020 - {new Date().getFullYear()} 韩漫网站. 韩国漫画免费在线阅读，下拉式韩漫全集尽在掌握。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:text-primary-400 hover:bg-foreground-700 transition-colors duration-200 cursor-pointer" rel="nofollow">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:text-primary-400 hover:bg-foreground-700 transition-colors duration-200 cursor-pointer" rel="nofollow">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:text-primary-400 hover:bg-foreground-700 transition-colors duration-200 cursor-pointer" rel="nofollow">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}